<template>
    <div class="hero-page">
        <div class="hero-content">
            <div class="limited-width-md">
                <users-auth-register-component></users-auth-register-component>
            </div>

            <div class="col-md-12 d-flex flex-column align-items-center mb-3" v-html="translate.login.registrationJoinNow">
            </div>

            <div class="col-md-12">
                <h2 class="heading-xl text-center mb-4">{{ translate.login.whyRegister }}</h2>
            </div>

            <div class="d-flex flex-column justify-content-center">
                <div class="limited-width-lg">
                    <div class="container my-4">
                        <div class="row">
                            <registration-features-component></registration-features-component>

                            <div class="col-md-12 mt-4">

                                <accordion-component
                                        :content="benefits"
                                        :prefix="'whyRegister'">
                                </accordion-component>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="hero-image"></div>
    </div>
</template>

<script>
import AccordionComponent from "@/components/global/AccordionComponent.vue";

const data = () => {
    return {
        benefits: [
            {
                title: 'login.registrationBenefitsListTitle1',
                content: 'login.registrationBenefitsListContent1',
            },
            {
                title: 'login.registrationBenefitsListTitle2',
                content: 'login.registrationBenefitsListContent2',
            }
        ]
    }
}

export default {
    components: {AccordionComponent},
    data,
    computed: {
        ...mapState(['translate']),
    }
}
</script>

